import create from "zustand";
import { db } from "../../../../config/firebase.config";
import {
  collection,
  addDoc,
  setDoc,
  getDoc,
  serverTimestamp,
  getDocs,
  doc,
} from "firebase/firestore";
import { toast } from "react-toastify";
import { config } from "../alerts/index";
import axios from "axios";
export const useStore = create((set, get) => ({
  reviews: [],
  averageRating: 0,
  openCreateReviews: false,
  showReviewsState: false,
  displayReviewLoading: false,
  averageReviewCount: 0,
  createReview: async (payload, id) => {
    set({ displayReviewLoading: true });
    if (payload.agreeToTerms) {
      try {
        const response = await axios.post(
          "https://liv-app-integration.vercel.app/reviews-marketing",
          {
            email: payload.email,
          }
        );
        console.log(
          "🚀 ~ file: index.js:32 ~ createReview: ~ response:",
          response
        );
      } catch (error) {
        console.error("API Error", error);
        toast("There was an error subscribing", { ...config, type: "error" });
      }
    }
    try {
      await setDoc(doc(db, "reviews", id), {
        reviews: [
          ...get().reviews,
          {
            ...payload,
            active: false,
            createdAt: Date.now(),
          },
        ],
        id,
      });
      toast("Your review has been submitted", { ...config, type: "success" });
      set({
        displayReviewLoading: false,
        reviews: [
          ...get().reviews,
          {
            ...payload,
            active: false,
            createdAt: Date.now(),
          },
        ],
      });
    } catch (error) {
      set({ displayReviewLoading: false });
      console.log(error.message, "error");
      return error.message;
    }
  },
  getAllReviews: async (id) => {
    try {
      const docRef = doc(db, "reviews", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        set({ reviews: data.reviews });
      } else {
        set({ reviews: [] });
      }
    } catch (error) {
      console.log("error on get all reviews", error);
    }
  },
  toggleCreateReviewState: async () => {
    set((state) => ({
      openCreateReviews: !state.openCreateReviews,
    }));
  },
  calculateAverageReviewCount: () => {
    const { reviews } = get();
    if (reviews.length) {
      const formattedReviewCount = reviews.map((review) => {
        return parseInt(review.rating);
      });

      let average =
        formattedReviewCount.reduce((a, b) => a + b) /
        formattedReviewCount.length;
      set({ averageReviewCount: average });
    }
  },
}));
